export const getMiles = (meters: number) => {
  const miles = meters * 0.000621371192
  return Math.round(miles * 10) / 10
}

export const getKilometers = (meters: number) => {
  const km = meters / 1000
  return Math.round(km * 10) / 10
}

const KM_SITES = ['OSH', 'HH', 'POSH', 'SK']

export const useKilometers = (): boolean => {
  return KM_SITES.includes(process.env.GATSBY_SITE_ENVIRONMENT || '')
}

export const getDistanceLabel = (meters: number): string => {
  if (useKilometers()) {
    return `${getKilometers(meters)} km away`
  }
  return `${getMiles(meters)} miles away`
}
